// Returns array of ICP names that match the given account
export function getMatchingICPs(account, icps) {
  if (!account || !icps?.length) return [];
  const F = (rec, f) => { const v = rec?.fields?.[f]; return v != null ? String(v) : ''; };
  const accIndustry = F(account, 'Industry').toLowerCase();
  const accCountry = F(account, 'Country').toLowerCase();
  return icps.filter(icp => {
    const icpIndustry = F(icp, 'Industry').toLowerCase();
    const icpCountry = F(icp, 'Country').toLowerCase();
    // Industry match: any word overlap
    const industryMatch = icpIndustry && accIndustry &&
      icpIndustry.split(/[/,]+/).map(s => s.trim()).some(w => w && accIndustry.includes(w));
    if (!industryMatch) return false;
    // Country match: if ICP specifies country, it must overlap; if not specified, pass
    if (icpCountry) {
      const countryMatch = icpCountry.split(/[/,]+/).map(s => s.trim()).some(w => w && accCountry.includes(w));
      if (!countryMatch) return false;
    }
    return true;
  }).map(icp => F(icp, 'Name'));
}
